import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-506e75cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap justify-content-end mb-4" }
const _hoisted_2 = { class: "d-lg-flex mb-3" }
const _hoisted_3 = { class: "me-lg-4" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "table-responsive mb-4 text-break" }
const _hoisted_6 = { class: "table table-borderless w-max-content" }
const _hoisted_7 = { class: "align-middle text-center" }
const _hoisted_8 = {
  key: 0,
  class: "rounded-top"
}
const _hoisted_9 = { class: "rounded-top" }
const _hoisted_10 = { class: "align-items-center" }
const _hoisted_11 = {
  key: 0,
  class: "default__width"
}
const _hoisted_12 = ["checked", "onChange"]
const _hoisted_13 = { class: "w_150" }
const _hoisted_14 = { class: "w-200" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "text-break" }
const _hoisted_18 = { class: "text-break w-200" }
const _hoisted_19 = {
  key: 1,
  class: "default__width"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = {
  key: 2,
  class: "default__width"
}
const _hoisted_24 = { class: "w_150" }
const _hoisted_25 = { class: "default__width" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-danger" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "text-center fw-bold"
}
const _hoisted_30 = { class: "d-lg-flex mb-3" }
const _hoisted_31 = { class: "me-lg-4" }
const _hoisted_32 = { class: "d-flex align-items-center" }
const _hoisted_33 = {
  class: "modal fade",
  id: "confirmDeleteModal",
  tabindex: "-1",
  "aria-labelledby": "confirmDeleteModal",
  "aria-hidden": "true"
}
const _hoisted_34 = { class: "modal-dialog" }
const _hoisted_35 = ["onSubmit"]
const _hoisted_36 = { class: "modal-content" }
const _hoisted_37 = { class: "modal-header" }
const _hoisted_38 = {
  class: "modal-title text-center fw-bold w-100",
  id: "confirmDeleteModalHeader"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_40 = { class: "modal-body" }
const _hoisted_41 = { class: "row justify-content-center" }
const _hoisted_42 = { class: "col-lg-10 gx-0 mx-0 d-flex fs-7" }
const _hoisted_43 = { class: "me-2" }
const _hoisted_44 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_45 = {
  class: "modal fade",
  id: "successDeleteModal",
  tabindex: "-1",
  "aria-labelledby": "successDeleteModal",
  "aria-hidden": "true"
}
const _hoisted_46 = { class: "modal-dialog" }
const _hoisted_47 = { class: "modal-content" }
const _hoisted_48 = { class: "modal-header" }
const _hoisted_49 = {
  class: "modal-title text-center fw-bold w-100",
  id: "SuccessDeleteModalHeader"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_51 = { class: "" }
const _hoisted_52 = { class: "text-center my-4" }
const _hoisted_53 = { class: "d-flex justify-content-center modal-footer" }

import { ref, watchEffect, onMounted, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

import Button from '@/components/button/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import Pagination from '@/components/pagination/index.vue'
import CellSort from '@/components/sort-field-table/index.vue'
import { translate } from '@/languages/i18n'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import TotalRecords from '@/components/total-records/index.vue'
import Loading from '@/components/loading/index.vue'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'
import _ from 'lodash'
import groupsService from '@/services/groups.service'
import { Modal } from 'bootstrap'
import { GROUPS_STORE } from '@/store/constants'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()
const data = ref<any[]>([])
const dataUsers = ref<any[]>([])
const dataDelete = ref<any[]>([])
const deleteFailed = ref<boolean>(false)
const totalPages = ref<number>(1)
const totalRecords = ref<number>(0)
const isCheckedAll = ref(false)
const listUserNo = ref<any[]>([])
const buttonDisable = ref(false)
const modalConfirmDeleteModal = ref()
const modalSuccessDeleteModal = ref()

const detailGroup = computed(() => store.getters[GROUPS_STORE.GETTERS.DETAIL_GROUPS])

onMounted(() => {
  getGroupUsers()
  modalConfirmDeleteModal.value = new Modal(document.getElementById('confirmDeleteModal'))
  modalSuccessDeleteModal.value = new Modal(document.getElementById('successDeleteModal'))
})

const getGroupUsers = async (isCheckedAllUser = false) => {
  const params = {
    ...route.query,
    create_by_admin: true,
    get_all_data: isCheckedAllUser,
  }
  try {
    const response = await groupsService.getAminGroupUserList(route?.params?.id, route?.params?.group_id, params)
    if (response?.status === 200) {
      if (!isCheckedAllUser) {
        dataUsers.value = response?.data?.data
        totalPages.value = response?.data?.total_pages
        totalRecords.value = response?.data?.total_records
      } else {
        listUserNo.value = response?.data?.data.filter((item) => item.is_deleted_in_30_days === 0 && item.available)
      }
    } else if (response?.response?.status === 404) {
      router.push('/404')
    }
  } catch (error) {
    console.log(error)
  }
}

watchEffect(() => {
  data.value = dataUsers.value?.map((item: any) => {
    return { ...item, isChecked: false }
  })
})

const deleteUser = async (): Promise<void> => {
  const params = {
    create_by_admin: true,
    user_type: dataDelete.value?.user_type,
  }
  try {
    const response = await groupsService.adminRemoveGroupUser(route?.params?.id, route?.params?.group_id, dataDelete.value?.user_id, params)
    if (response?.status === 200) {
      deleteFailed.value = false
      getGroupUsers()
    } else {
      deleteFailed.value = true
    }
  } catch (error) {
    console.log(error)
    deleteFailed.value = true
  }
  modalConfirmDeleteModal.value.hide()
  modalSuccessDeleteModal.value.show()
}
const setDeleteData = (data: any) => {
  dataDelete.value = data
  modalConfirmDeleteModal.value.show()
}

const getDetailGroup = async () => {
  const params = {
    create_by_admin: true,
  }

  let response: any
  try {
    response = await groupsService.getDetailGroupApi(route?.params?.group_id, params)
  } catch (error) {
    console.log('err', error)
  }

  return response?.data?.data?.group
}

const transitToAlumniList = () => {
  router.push(`/community/communities/${route.params?.id}/alumnus?page=1&management_no=desc`)
}
const transitToUserList = () => {
  router.push(`/community/communities/${route.params?.id}/community-users?page=1&management_no=desc`)
}
const handleTransitDetail = (idUser: string): void => {
  const userType = idUser.charAt(0) === 'A' ? 'alumnus' : 'community-users'
  router.push(`/community/communities/${route.params?.id}/${userType}/${idUser}/edit`)
}

const transitToGroupInvitation = async () => {
  const newDetailGroup = await getDetailGroup()
  if (newDetailGroup?.published) {
    store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_RECORD_SELECTED, listUserNo.value)
    router.push(`/community/communities/${route.params?.id}/admin/groups/send_invitation_messages`)
    //transit to OE90
  } else {
    // Reload page if group.published was changed to private
    router.go()
  }
}

const handleCheckID = (user: any) => {
  if (!_.map(listUserNo.value, 'user_no').includes(user.user_no)) {
    listUserNo.value.push(user)
  } else {
    _.remove(listUserNo.value, { user_no: user.user_no })
  }
  isCheckedAll.value = listUserNo.value?.length === totalRecords.value
}

const loadingCheckAll = ref<boolean>(false)
const handleCheckAll = async (): Promise<void> => {
  if (isCheckedAll.value) {
    loadingCheckAll.value = true
    await getGroupUsers(true)
    loadingCheckAll.value = false
  } else {
    listUserNo.value = []
  }
}

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

watch(
  [
    () => route.query?.page,
    () => route.query?.page_of_number,
    () => route.query?.email,
    () => route.query?.user_no,
    () => route.query?.customer_name,
    () => route.query?.invitation_status,
    () => route.query?.invitation_date,
  ],
  () => {
    if (route.path.match(`/community/communities/${route?.params?.id}/admin/groups/${route?.params?.group_id}/edit`)) {
      getGroupUsers()
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Button, {
          title: _unref(translate)('OE50toAlumni'),
          type: "secondary",
          "class-name": "me-lg-4 mb-4",
          onClick: transitToAlumniList
        }, null, 8, ["title"]),
        _createVNode(Button, {
          title: _unref(translate)('OE50toEmployee'),
          type: "secondary",
          "class-name": "me-lg-4 mb-4",
          onClick: transitToUserList
        }, null, 8, ["title"]),
        (_unref(detailGroup).invitation_group)
          ? (_openBlock(), _createBlock(Button, {
              key: 0,
              title: _unref(translate)('sendInviteOnlyGroupButton'),
              type: "secondary",
              "class-name": "me-lg-4 mb-4",
              onClick: transitToGroupInvitation,
              disabled: listUserNo.value.length === 0 || !_unref(detailGroup).published
            }, null, 8, ["title", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(TotalRecords, {
          totalRecords: totalRecords.value,
          totalChecked: listUserNo.value.length,
          isChecked: true
        }, null, 8, ["totalRecords", "totalChecked"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Pagination, {
              totalDataOfPage: dataUsers.value?.length,
              totalPage: totalPages.value,
              changDelete: true
            }, null, 8, ["totalDataOfPage", "totalPage"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(SelectCustom, {
              options: dataSelectRecordPerPage.value,
              keyName: "page_of_number"
            }, null, 8, ["options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_7, [
                (_unref(detailGroup).invitation_group)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_8, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input cursor-pointer",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isCheckedAll).value = $event)),
                          onChange: handleCheckAll,
                          value: "",
                          id: "flexCheckDefault"
                        }, null, 544), [
                          [_vModelCheckbox, isCheckedAll.value]
                        ])
                      ]),
                      _createElementVNode("div", null, _toDisplayString(_unref(translate)('OE10selectAll')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('managementNo'),
                    keyName: "user_no"
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('fullName'),
                    keyName: "customer_name"
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('email'),
                    keyName: "email"
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('groupInvitationStatus'),
                    keyName: "invitation_status"
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(CellSort, {
                    title: _unref(translate)('groupInvitationDate'),
                    keyName: "invitation_date"
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("th", _hoisted_9, _toDisplayString(_unref(translate)('delete')), 1)
              ])
            ]),
            _createElementVNode("tbody", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: _normalizeClass(["align-middle text-center", {
                rowEven: index % 2 === 0,
                rowChecked: _unref(_).map(listUserNo.value, 'user_no').includes(item.user_no),
              }]),
                  key: index
                }, [
                  (_unref(detailGroup).invitation_group)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                        (item.available && item.is_deleted_in_30_days === 0)
                          ? (_openBlock(), _createElementBlock("input", {
                              key: 0,
                              class: "form-check-input cursor-pointer",
                              checked: _unref(_).map(listUserNo.value, 'user_no').includes(item.user_no),
                              onChange: ($event: any) => (handleCheckID(item)),
                              type: "checkbox",
                              id: "flexCheckDefault"
                            }, null, 40, _hoisted_12))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.user_no), 1),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(UserAliasIcon, {
                        userType: item?.user_type
                      }, null, 8, ["userType"]),
                      _createElementVNode("div", {
                        class: "text-decoration-underline cursor-pointer",
                        onClick: () => handleTransitDetail(item?.user_no)
                      }, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(item.family_name + ' ' + item.given_name + (item.user_type === 2 ? `（${item.display_name}）` : '')), 1)
                      ], 8, _hoisted_16)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(item.email || '-'), 1),
                  (_unref(detailGroup).invitation_group)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                        (item.invitation_status === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(translate)('NotInvitedToGroup')), 1))
                          : _createCommentVNode("", true),
                        (item.invitation_status === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(translate)('invitedToGroup')), 1))
                          : _createCommentVNode("", true),
                        (item.invitation_status === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(translate)('participatingInGroup')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(_unref(translate)('participatingInGroup')), 1)),
                  _createElementVNode("td", _hoisted_24, _toDisplayString(item.created_at ? _unref(ConvertFromLocalTime)(item.created_at) : '-'), 1),
                  _createElementVNode("td", _hoisted_25, [
                    (!item.is_admin)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "cursor-pointer",
                          "data-bs-Toggle": "modal",
                          onClick: ($event: any) => (setDeleteData(item))
                        }, _hoisted_28, 8, _hoisted_26))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          (!dataUsers.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(translate)('CC10noData')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(Pagination, {
              totalDataOfPage: dataUsers.value?.length,
              totalPage: totalPages.value,
              changDelete: true
            }, null, 8, ["totalDataOfPage", "totalPage"])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(SelectCustom, {
              options: dataSelectRecordPerPage.value,
              keyName: 'page_of_number'
            }, null, 8, ["options"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(deleteUser, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("h5", _hoisted_38, _toDisplayString(_unref(translate)('deleteGroupUser')), 1),
              _hoisted_39
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(UserAliasIcon, {
                    userType: dataDelete.value?.user_type
                  }, null, 8, ["userType"]),
                  _createElementVNode("p", _hoisted_43, _toDisplayString(dataDelete.value?.user_no +
                  ' ' +
                  dataDelete.value?.family_name +
                  ' ' +
                  dataDelete.value?.given_name +
                  (dataDelete.value?.user_type === 2 ? `（${dataDelete.value?.display_name}）` : '') +
                  _unref(translate)('deleteGroupUserContent')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createVNode(Button, {
                title: _unref(translate)('CloseButton'),
                type: "secondary",
                "data-bs-dismiss": "modal",
                class: "me-lg-3",
                className: "fw-bold"
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('deleteButton'),
                type: "secondary",
                loading: buttonDisable.value,
                disabled: buttonDisable.value,
                htmlType: "submit",
                className: "fw-bold"
              }, null, 8, ["title", "loading", "disabled"])
            ])
          ])
        ], 40, _hoisted_35)
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("h5", _hoisted_49, _toDisplayString(_unref(translate)('deleteGroupUser')), 1),
            _hoisted_50
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("p", _hoisted_52, _toDisplayString(deleteFailed.value ? _unref(translate)('errorDeleteGroupUser') : _unref(translate)('deleteSuccess')), 1)
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: "secondary",
              "data-bs-dismiss": "modal",
              className: "fw-bold"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ]),
    _createVNode(Loading, { loading: loadingCheckAll.value }, null, 8, ["loading"])
  ], 64))
}
}

})